var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MultiColorIcon-path--fadedBlack",
    focusable: "false",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "MultiColorIcon-path--white",
    d: "M99,119H21c-11,0-20-9-20-20V21C1,10,10,1,21,1h78c11,0,20,9,20,20v78C119,110,110,119,99,119z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#778ca2",
    className: "MultiColorIcon-path--grey",
    d: "M71,59H61V49c0-0.5-0.4-1-1-1s-1,0.4-1,1V59H49c-0.5,0-1,0.4-1,1s0.4,1,1,1H59V71c0,0.5,0.4,1,1,1s1-0.4,1-1V61H71c0.5,0,1-0.4,1-1S71.6,59,71,59z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.4b453a19.svg";
export { ForwardRef as ReactComponent };